import { Context } from '../index'
import { SHARE_EVENT_TYPE, LOGGER_PREFIX } from '../constants'

export default class Share {
  private context: Context

  constructor(context: Context) {
    this.context = context
    const { pm } = context

    if (pm) {
      this.addEventListener()
    }
  }

  public showSharePannel(): void {
    console.log(`[${LOGGER_PREFIX}] show share pannel`)

    const { provider } = this.context

    if (provider) {
      // 打开分享面板
      provider.showShare()
    }
  }

  private addEventListener(): void {
    const { pm } = this.context

    // 打开分享面板
    pm.on(SHARE_EVENT_TYPE, () => {
      this.showSharePannel()
    })
  }
}
